export const CUSTOMER_HEADER_COLUMNS = {
  CUSTOMER_NAME: 'Customer Name',
  DATE_OF_BIRTH: 'Date of Birth',
  ADDRESS: 'Address',
  POST_CODE: 'Postcode',
  MOBILE_NUMBER: 'Contact No.',
  CUSTOMER_NUMBER: 'Customer No.',
};

export const CLICK_HERE_REGISTER_MESSAGE = `Click here to Register Customer`;
export const SORRY_MESSAGE = `Sorry we couldn't find any matches for`;

export const APP_MAX_IDLE_TIME = 15; // in minutes
export const LOGOUT_COUNTER_DURATION = 60; // in seconds

export const CASH_MANAGEMENT_ALERT = `Please 'Exit and Clear' or 'Exit and Save' customers journey and then open Cash/Inventory/Pledge management`;

export const SAR_FORM_LINK = `https://docs.google.com/forms/d/e/1FAIpQLSdTTk0BrU9QJ-JE7o2AN2e6UvoDQrtc2YvJbOmaNDpiy-QNIg/viewform`;

export const RECALL_MENU_LABELS = {
  TITLE: 'Recall Session',
  SEARCH_BY: 'Search by',
  RESTORE: 'Restore',
  CANCEL: 'Cancel',
  TABLE_HEADERS: {
    SERVICE_TYPE: 'Service Type',
    AMOUNT: 'Amount',
    EXPIRES: 'Expires',
  },
  ERROR_MSG:
    'Please complete the current customers committed journey before recalling from the guest recall',
  MERGE_BASKET_ERROR:
    'The customer already has a committed transaction within the checkout. You will be directed to complete the customers journey before commencing any other services. The current basket will be saved to the guest recall.',
};

export const DAILY_INTEREST_TABS = {
  DAILY_INTEREST: 'Daily Interest',
  APR: 'APR',
  DUE: 'Due',
  MONTHLY_INTEREST_RATE: 'Monthly Interest Rate',
};

export const PAYDOWN_CALCULATOR = {
  HEADING: 'Paydown Calculator',
  LOAN_VALUE: 'Loan Value',
  MONTHLY_INTEREST_RATE: 'Monthly Interest Rate',
  NUMBER_OF_PAYMENTS: 'Number of Payments',
  NORMAL_PAWNBROKING_INTEREST: 'Normal Pawnbroking Interest (over 6 months)',
  INTEREST_ON_THIS_PAYDOWN: 'Interest on this Paydown',
  INTEREST_SAVED: 'Interest Saved',
  NO_OF_MONTHS: 'No. of Months',
  MONTHLY_PAYMENT: 'Monthly Payment',
  TOTAL_PAID: 'Total Paid',
  PAYDOWN_INTEREST: 'Paydown Interest',
  STATEMENT_HEADING: 'Statement',
};

export const PAYDOWN_DEFAULT_VALUES = {
  AMOUNT: 0.0,
  INTEREST_RATE: 10.49,
  NUMBER_OF_PAYMENTS: 6,
};

export const ACCESSORIES_COMMON_MODAL = {
  INITIAL_PANES: [
    { title: 'Daily Interest Calculator', width: 300, minWidth: '35%' },
    { title: 'Metal Pricing', minWidth: '30%' },
    { title: 'Stone Size Calculator', width: 340, minWidth: '35%' },
  ],
};

export const ACCESSORIES_LINKS = {
  DAILY_INTEREST_CALCULATOR: 'Daily Interest Calculator',
  PAYDOWN_CALCULATOR: 'Paydown Calculator',
  PRE_CONTRACT_CREDIT_INFO: 'Pre-Contract Credit Information',
  PLEDGE_AGREEMENT: 'Pledge Agreement',
  INTEREST_RATE_BANDS: 'Interest Rate Bands',
  METAL_PRICING: 'Metal Pricing',
  SUSPICIOUS_ACTIVITY_REPORT: 'Suspicious Activity Report',
  CUSTOMER_THIRD_PARTY_CHEQUE_MANDATE: 'Customer Third Party Cheque Mandate',
  CLEAN_MONEY: 'Print Certificate of Clean Money',
  UNDER_75_AFFIDAVIT: 'Under £75 Affidavit',
  OVER_75_AFFIDAVIT: 'Over £75 Affidavit',
  LAYAWAY_AGREEMENT: 'Layaway Agreement',
  TEXAS_TOOL: 'TEXAS Tool',
  BRUCE_PROTOCOL: 'BRUCE Protocol',
  STONE_SIZE_CALCULATOR: 'Stone Size Calculator',
  TELEPHONE_LIST: 'Telephone List',
};

export const AFFIDAVIT_TYPE = {
  UNDER_75_AFFIDAVIT: '3GBP',
  OVER_75_AFFIDAVIT: '5GBP',
  PLEDGE_AGREEMENT: 'BLANK_PLEDGE_AGREEMENT',
};

export const AGREEMENT_TO_PRINTER = `Agreement has been sent to the printer successfully.`;
export const AFFIDAVIT_TO_PRINTER = `Affidavit has been sent to the printer successfully.`;
export const CUSTOMER_MANDATE_TO_PRINTER = `Customer Third Party Cheque Mandate has been sent to the printer successfully.`;

export const PAYDOWN_STATEMENT_TO_PRINTER = `Paydown Statement has been sent to the printer successfully.`;
export const PRE_CONTRACT_CREDIT_INFO_TO_PRINTER = `Pre-Contract Credit Information has been sent to the printer successfully.`;

export const TEXAS_TOOL_TO_PRINTER = `Texas Tool has been sent to the printer successfully.`;
export const COCM_TO_PRINTER = `Certificate of Clean Money has been sent to the printer successfully.`;
export const BRUCE_PROTOCOL_TO_PRINTER = `Bruce Protocol has been sent to the printer successfully.`;

export const TELEPHONE_LIST_TABS = {
  SEARCH_BY_STORE: 'Search by Store',
  SEARCH_BY_COLLEAGUE: 'Search by Colleague',
};

export const STONE_SIZE_CALCULATION_EXAMPLE =
  ' e.g. : (Average Diameter) x (Average Diameter) x Depth x 0.0061=ct';

export const SORTED_INDEX_METALPRICE_LIST = [
  '9 CT',
  '14 CT',
  '18 CT',
  '21 CT',
  '22 CT',
  'PLATINUM',
  'PALLADIUM',
];

export const METALTYPE = {
  SILVER: 'SILVER',
};

export const SILVEROBJ = [
  {
    carat: METALTYPE.SILVER,
    spot: 0,
    rateStart: 0.35,
    high: 0.35,
  },
];

export const RESERVE_CURRENCY_ADVISORY =
  'If funds are held in a user(s) till you will be required to cash transfer to the main safe.';

export const VIEW_DOCUMENT_BUTTONS = {
  CANCEL: 'Cancel',
  PRINT: 'Print',
};

export const VIEW_DOCUMENT_TYPES = [
  ACCESSORIES_LINKS.BRUCE_PROTOCOL,
  ACCESSORIES_LINKS.TEXAS_TOOL,
  ACCESSORIES_LINKS.CLEAN_MONEY,
];
export const MAX_RATE_BAND = 999999;

export const DOCUMENT_LOADING = 'Loading Document...';
export const DOCUMENT_CANNOT_LOAD = 'Document cannot load...';

export const LAYAWAY_AGREEMENT_SUCCESS_MESSAGE =
  'Layaway Agreement has been sent to printer successfully.';

export const METAL_PRICING_GRID_HEADERS = {
  CARAT: {
    NAME: 'carat',
    TITLE: 'Carat',
  },
  SPOT: {
    NAME: 'spot',
    TITLE: 'Spot',
  },
  LOW_RATE: {
    NAME: 'rateStart',
    TITLE: 'Low',
  },
  HIGH_RATE: {
    NAME: 'high',
    TITLE: 'High',
  },
};

export const INTEREST_RATE_GRID_HEADERS = {
  LOAN_VALUE: {
    NAME: 'loanValue',
    TITLE: 'Loan Value (£)',
  },
  INTEREST_RATE: {
    NAME: 'interestRate',
    TITLE: 'Interest Rate',
  },
  APR: {
    NAME: 'apr',
    TITLE: 'APR',
  },
};

export const PAYDOWN_STATEMENT_GRID_HEADERS = {
  PAYMENT_DATE: {
    NAME: 'paymentDate',
    TITLE: 'Date',
  },
  INTEREST: {
    NAME: 'interest',
    TITLE: 'Interest',
  },
  PAID_AMOUNT: {
    NAME: 'paidAmount',
    TITLE: 'Paid',
  },
  BALANCE: {
    NAME: 'balance',
    TITLE: 'Balance',
  },
};

export const TELEPHONE_LIST_GRID_HEADERS = {
  STORE_ID: {
    NAME: 'storeId',
    TITLE: 'Store ID',
  },
  STORE_NAME: {
    NAME: 'storeName',
    TITLE: 'Store Name',
  },
  AREA_MANAGER: {
    NAME: 'areaManager',
    TITLE: 'Area Manager',
  },
  STORE_MANAGER: {
    NAME: 'storeManager',
    TITLE: 'Store Manager',
  },
  STORE_ADDRESS: {
    NAME: 'storeAddress',
    TITLE: 'Store Address',
  },
  POSTCODE: {
    NAME: 'postcode',
    TITLE: 'Postcode',
  },
  TELEPHONE_NUMBER: {
    NAME: 'telephoneNumber',
    TITLE: 'Telephone Number',
  },
};

export const RESERVED_CURRENCY_GRID_HEADERS = {
  CUSTOMER: {
    NAME: 'customerName',
    TITLE: 'Customer Name',
  },
  COLLECTION_DATE: {
    NAME: 'collectionDate',
    TITLE: 'Collection Date',
  },
  CURRENCY: {
    NAME: 'currency',
    TITLE: 'Currency',
  },
  AMOUNT: {
    NAME: 'amount',
    TITLE: 'Amount',
  },
};

export const END_DAY_WARNING_STORE_POPUP = {
  WARNING: 'Warning !',
  MESSAGE: 'End of day process has been run for this store',
  SECONDARY_MSG:
    'If any actions are processed the End of day process will need to be actioned again.',
};
